// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"101":"Confirm","694":"Request"}[chunkId] + "." + {"101":"76ffd9e8","694":"eda5570b"}[chunkId] + ".chunk.css";
};